<template>
	<div :class="{ 'com-borda': layout === 'COM_BORDA' }">
		<v-tabs
			:hide-slider="hideSlider"
			v-model="tabAtual"
			:fixed-tabs="!$vuetify.breakpoint.smAndUp"
			:vertical="!$vuetify.breakpoint.smAndUp"
		>
			<v-tab
				v-for="tab in tabsAtivas"
				:key="tab.id"
				class="tab-header"
				active-class="tab-ativa"
				v-show="tab.isVisible()"
			>
				{{ tab.titulo }}
				<div class="mx-2">
					<icone-simples-redondo-com-label
						v-if="tab.contador > 0"
						:texto="tab.msgIcone"
						:cor-background="tab.corIcone"
						:label-botao="tab.contador"
					></icone-simples-redondo-com-label>
				</div>

				<slot :name="tab.slot + 'contador'"></slot>
			</v-tab>
			<v-spacer
				class="border-bottom d-flex align-content-stretch align-content-sm-end justify-sm-end align-sm-center me-0 me-sm-auto"
			>
				<div class="my-2">
					<slot name="acoes-tabs"></slot>
				</div>
			</v-spacer>
		</v-tabs>
		<v-divider v-if="layout === 'SEM_BORDA'"></v-divider>
		<v-tabs-items v-model="tabAtual">
			<v-tab-item v-for="tab in tabsAtivas" :key="tab.id" class="border-tab">
				<slot :name="tab.slot"></slot>
			</v-tab-item>
		</v-tabs-items>
	</div>
</template>
<script>
import IconeSimplesRedondoComLabel from '@/views/components/icones/IconeSimplesRedondoComLabel.vue'

export default {
	name: 'painel-com-tabs-sem-rotas',
	components: { IconeSimplesRedondoComLabel },
	props: {
		tabs: {
			type: Array,
			required: true,
		},
		hideSlider: {
			type: Boolean,
			default: true,
		},
		layout: {
			type: String,
			default: 'COM_BORDA',
		},
	},
	data() {
		return {
			tabAtual: null,
		}
	},
	computed: {
		tabsAtivas() {
			return this.tabs.filter((tab) => tab.isVisible())
		},
	},
	watch: {
		tabAtual(valorDaTab) {
			this.$emit('tab-atual', valorDaTab)
		},
	},
}
</script>
<style scoped lang="stylus">
.com-borda

	.tab-header
		border 1px solid #CDCDCD

	.tab-ativa
		border-bottom: none

	.border-bottom
		border-bottom 1px solid #CDCDCD
</style>
